import { render, staticRenderFns } from "./MyAccountNavigation.vue?vue&type=template&id=2d377a10&scoped=true"
import script from "./MyAccountNavigation.vue?vue&type=script&lang=js"
export * from "./MyAccountNavigation.vue?vue&type=script&lang=js"
import style0 from "./MyAccountNavigation.vue?vue&type=style&index=0&id=2d377a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d377a10",
  null
  
)

export default component.exports